import React from 'react';
import { MenuItem } from 'react-toolbox/lib/menu';
import styles from 'components/faceted-search/FacetMenuItem.css';

const FacetMenuItem = ({ value, caption, onClick }) =>
  <MenuItem theme={styles} caption={caption} onClick={onClick} value={value} />;

export default FacetMenuItem;
